export const DEFAULT_TAB_ANALYTICS_EVENTS = {
  saved: "default tab saved",
  cleared: "default tab cleared"
} as const;

export type AmplitudeTrackEvent = (eventName: string, eventProperties?: Record<string, unknown>) => void;

export type DefaultTabSavedAnalyticsPayload = {
  navigationGroup: string;
  tabSlug: string;
  source: "tab_bar";
  success: true;
  previousTabSlug?: string;
};

export type DefaultTabClearedSource = "preferences" | "tab_bar";

export type DefaultTabClearedAnalyticsPayload = {
  source: DefaultTabClearedSource;
  success: true;
  clearedGroupCount: number;
  navigationGroups: string[];
  tabSlug?: string;
};

function compactPayload<T extends Record<string, unknown>>(payload: T): T {
  return Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== undefined && value !== null)) as T;
}

export function getDefaultTabSavedAnalyticsPayload({
  navigationGroup,
  tabSlug,
  previousTabSlug
}: {
  navigationGroup: string;
  tabSlug: string;
  previousTabSlug?: string | null;
}): DefaultTabSavedAnalyticsPayload {
  return compactPayload({
    navigationGroup,
    tabSlug,
    source: "tab_bar",
    success: true,
    previousTabSlug: previousTabSlug || undefined
  });
}

export function getDefaultTabClearedAnalyticsPayload(
  navigationGroups: string[],
  options?: { source?: DefaultTabClearedSource; tabSlug?: string | null }
): DefaultTabClearedAnalyticsPayload {
  return compactPayload({
    source: options?.source ?? "preferences",
    success: true,
    clearedGroupCount: navigationGroups.length,
    navigationGroups,
    tabSlug: options?.tabSlug || undefined
  });
}

export function trackDefaultTabSaved(
  trackEvent: AmplitudeTrackEvent,
  input: {
    navigationGroup: string;
    tabSlug: string;
    previousTabSlug?: string | null;
  }
) {
  trackEvent(DEFAULT_TAB_ANALYTICS_EVENTS.saved, getDefaultTabSavedAnalyticsPayload(input));
}

export function trackDefaultTabCleared(
  trackEvent: AmplitudeTrackEvent,
  navigationGroups: string[],
  options?: { source?: DefaultTabClearedSource; tabSlug?: string | null }
) {
  trackEvent(DEFAULT_TAB_ANALYTICS_EVENTS.cleared, getDefaultTabClearedAnalyticsPayload(navigationGroups, options));
}
